export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";